module.exports = __webpack_public_path__ + "img/A918.242d6467.jpg";